import * as React from 'react'
import _ = require('lodash')
import { toast } from 'react-toastify'
import { homeService, itemService } from '../../../../services'
import {
  Button,
  Divider,
  Dropdown,
  Form,
  Grid,
  GridColumn,
  Header,
  Icon,
  Label,
  Segment,
  DropdownItemProps
} from 'semantic-ui-react'
import { GameItemDeck } from '../../components'
import { DropdownProps } from 'semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown'
import { RequestRollSuccessInfo } from './containers/RequestRollSuccessInfo'
import { common } from '../../../../utils/common'
import { InfoTab } from './components/InfoTab'
import { connect } from 'react-redux'
import RollItemStoreUser from './RollItemStoreUser'
import MarqueeBanner from './containers/MarqueeBanner'
import RollItemStoreAdmin from './RollItemStoreAdmin'

type RollItemStoreState = {
  isLoading: boolean,
  availableRollItems: IGameItem[],
  pickedRollItems: IGameItem[],
  userTopInfo: IUserTopInfo,
  userTopId: string,
  bank: string,
  requestSuccess: boolean,
  rollRequest?: IRollRequest,
  rollRequestInfo?: IRollRequestInfo,
  validBankInfoList: DropdownItemProps[],
}

type RollItemStoreProps = {
  isLoggedIn: boolean,
  user: IUser,
}

class RollItemStore extends React.Component<RollItemStoreProps> {
  state: RollItemStoreState = {
    isLoading: true,
    availableRollItems: [],
    pickedRollItems: [],
    userTopId: '',
    bank: '',
    requestSuccess: false,
    userTopInfo: {
      nickname: '',
      steamId: ''
    },
    validBankInfoList: [],
  }

  componentDidMount() {
    this.getAvailableItem()
    homeService.getBankInfoList()
      .then(value => this.setState({
        validBankInfoList: _.chain(value)
          .filter('active')
          .sortBy(['priority'])
          .map(function (bankInfo: IBankInfo): DropdownItemProps {
            return {value: bankInfo.code, text: bankInfo.name}
        }).value()
      }))
  }

  getAvailableItem = async () => {
    try {
      this.setState({isLoading: true})
      const response = await itemService.getRollItems()
      this.setState({
        isLoading: false,
        availableRollItems: response,
        pickedRollItems: []
      })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handlePickItem = (item: IGameItem) => {
    let items = this.state.availableRollItems
    const index = items.indexOf(item)
    if (index >= 0) {
      this.setState({
          availableRollItems: items.filter((v, i) => i !== index),
          pickedRollItems: this.state.pickedRollItems.concat(item)
        }
      )
    }
  }

  handleRemoveItem = (item: IGameItem) => {
    let items = this.state.pickedRollItems
    const index = items.indexOf(item)
    if (index >= 0) {
      this.setState({
          pickedRollItems: items.filter((v, i) => i !== index),
          availableRollItems: this.state.availableRollItems.concat(item)
        }
      )
    }
  }

  onBlurSteamId = (event: any) => {
    event.preventDefault()
    const value = event.target.value
    if (value && value.length > 3) {
      this.setState({
        userTopInfo: {
          steamId: undefined,
          nickname: undefined
        }
      })
      homeService.getUserTopInfo(value)
        .then(result => {
          this.setState({
            userTopInfo: result,
          })
        })
    }
  }

  onChangeSteamId = (event: any) => {
    this.setState({userTopId: event.target.value})
  }

  onChangeBank = (event: React.KeyboardEvent<HTMLElement>, data: DropdownProps) => {
    event.preventDefault()
    this.setState({
      bank: data.value
    })
  }

  onClickBuyItem = async () => {
    let {userTopInfo, pickedRollItems, bank, userTopId} = this.state
    if (!pickedRollItems || pickedRollItems.length <= 0) {
      toast.error('Bạn chưa chọn item!')
      return
    }
    if (!userTopInfo.steamId || !bank) {
      toast.error('Bạn không được bỏ trống steamId hoặc Thông tin thanh toán!')
      return
    }
    this.setState({
      isLoading: true,
      requestSuccess: false
    })
    const rollRequestInfo = {
      steamId: userTopInfo.steamId ? userTopInfo.steamId : userTopId,
      gameItems: pickedRollItems, bank: bank
    }
    itemService.requestRoll(rollRequestInfo)
      .then(rollRequest => {
        this.setState({
          isLoading: false,
          requestSuccess: true,
          rollRequest: rollRequest,
          rollRequestInfo: rollRequestInfo,
        })
        this.getAvailableItem()
      })
      .catch(reason => {
        toast.error(reason.message)
        this.setState({
          isLoading: false,
          requestSuccess: false,
          rollRequest: undefined,
          rollRequestInfo: undefined,
        })
      })
    window.scrollTo(0, 0)
  }

  render() {
    let {
      isLoading, availableRollItems, pickedRollItems,
      userTopId, requestSuccess, rollRequest, rollRequestInfo, userTopInfo, validBankInfoList
    } = this.state
    let {isLoggedIn, user} = this.props
    if (isLoggedIn && user && user.username && user.role === 'REGULAR_USER') {
      return (<RollItemStoreUser user={user}/>)
    }
    if (isLoggedIn && user && user.role === 'SUPER_ADMIN') {
      return (<RollItemStoreAdmin/>)
    }
    return (
      <div>
        <MarqueeBanner/>
        <div className="container store">
          <Segment loading={isLoading} style={{border: 'none', paddingBottom: '70px'}}>
            {requestSuccess && rollRequest && rollRequestInfo &&
            <RequestRollSuccessInfo rollRequest={rollRequest} rollRequestInfo={rollRequestInfo}/>}
            <InfoTab/>
            <Divider horizontal={true}/>

            <Grid columns={'2'} stackable={true} style={{border: 'none'}}>
              <GridColumn>
                <Header as={'h3'} attached={'top'}>
                  Chọn Item
                  <Button
                    floated={'right'}
                    size={'mini'}
                    color={'blue'}
                    onClick={this.getAvailableItem}
                  >
                    <Icon name="refresh"/>Tải lại
                  </Button>
                </Header>
                <GameItemDeck items={availableRollItems} onClickItem={this.handlePickItem}/>
              </GridColumn>
              <GridColumn>
                <Header as={'h3'} attached={'top'}>
                  Tổng giá trị:
                  {common.calculatePickedValue(pickedRollItems)} ~
                  {common.calculatePickedVnd(pickedRollItems).toLocaleString('vn') + 'vnd'}
                </Header>
                <div className="ui labeled input">
                  <div className="ui label label">SteamID/DigitalID</div>
                  <input
                    type="text"
                    value={userTopId}
                    onBlur={this.onBlurSteamId}
                    onChange={this.onChangeSteamId}
                  />
                </div>
                <h6>{userTopInfo.nickname ? userTopInfo.nickname : 'Không tìm thấy user'}</h6>
                <GameItemDeck items={pickedRollItems} onClickItem={this.handleRemoveItem} isCart={true}/>

                <Form>
                  <Label pointing={'right'}>Phương thức thanh toán</Label>
                  <Dropdown selection={true} options={validBankInfoList} onChange={this.onChangeBank}/>
                  <Button floated={'right'} color={'blue'} onClick={this.onClickBuyItem}>Mua</Button>
                </Form>
                <Divider/>
              </GridColumn>
            </Grid>
          </Segment>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
  ...ownProps,
  isLoggedIn: state.loggedIn,
  user: state.root.userInfo,
})

export default connect(mapStateToProps)(RollItemStore)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/RollItemStore/RollItemStore.tsx